import { bl_fi_entity_peppol_id_RowClass } from '../../../dbschema/bl_fi_entity_peppol_id.model';
import { BaseContainerModel } from '../../base-container.model';

export class EntityPeppolIDContainerModel extends BaseContainerModel {
    bl_fi_entity_peppol_id: bl_fi_entity_peppol_id_RowClass = new bl_fi_entity_peppol_id_RowClass();
}